import { Component, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { ActivatedRoute, Router } from '@angular/router';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { LegacyCompositionService } from '@services/legacy-compositions/legacy-composition.service';
import { ImportService } from '@services/imports/import.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import * as _ from 'lodash';
import { ImportTypeService } from '@services/import-types/import-type.service';

@Component({
    selector: 'app-legacy-composition-detail',
    templateUrl: './legacy-composition-detail.component.html',
    styleUrls: ['./legacy-composition-detail.component.scss'],
    providers: [CodeSnippetService, LegacyCompositionService, ImportService, ImportTypeService],
    standalone: false
})
export class LegacyCompositionDetailComponent implements OnInit {

  public title = 'Legacy-Composition';

  public subtitle: string;

  public pageActions: PageAction[];

  legacyComposition: Models.LegacyComposition;

  importIdsInfo: any;
  codeSnippetInfo: any;

  isLoading = false;

  public params: any;

  constructor(
    public codeSnippetService: CodeSnippetService,
    public legacyCompositionService: LegacyCompositionService,
    public importService: ImportService,
    public importTypeService: ImportTypeService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.legacyCompositionService.get(this.route.snapshot.params['id']).then(legacyComposition => {
      this.legacyComposition = legacyComposition;
      this.title = this.legacyComposition.title;
      this.subtitle = '';
      this.importIdsInfo = [{ 'id': null, 'title': 'No Imports for this Legacy Composition' }];
      this.codeSnippetInfo = [{ 'id': null, 'title': 'No Snippets for this Legacy Composition' }];

      if (this.legacyComposition.importIds) {
        const ids = this.legacyComposition.importIds.split('\n');
        this.loadData(ids);
      }

      if (this.legacyComposition.codeSnippetNames) {
        const snippets = this.legacyComposition.codeSnippetNames.split('\n');
        snippets.map((entry, index) => {
          this.codeSnippetService.find(0, 1, { name: entry }).then(result => {
            if (result.data[0]) {
              this.codeSnippetInfo[index] = { 'id': result.data[0]._id, 'title': entry, 'url': '/code-snippets/' + result.data[0]._id };
            } else {
              this.codeSnippetInfo[index] = { 'id': entry, 'title': entry, 'url': '', 'error': 'Snippet does not exist!' };
            }
          });
        });
      }
      this.isLoading = false;
    });
    this.createPageActions();
  }

  public generateArray(data) {
    return new Promise((resolve, reject) => {
      const array = [];
      data.map(entry => {
        this.importTypeService.get(entry.typeId).then(resultImportType => {
          const properties = (entry.importProperties && Object.keys(entry.importProperties).length !== 0 ?
            entry.importProperties : []);
          const assignable = (entry.assignableMenuItems && Object.keys(entry.assignableMenuItems).length !== 0 ?
            entry.assignableMenuItems : []);
          const fetchLog = resultImportType.title === 'GuidleEvents' || resultImportType.title === 'SBB Daily Schedules' || resultImportType.title === 'Ticker';
          array.push({
            id: entry._id,
            name: entry.title,
            url: '/imports/' + entry._id,
            importType: resultImportType.title,
            properties: properties,
            assignable: assignable,
            fetchLog: fetchLog,
          });
          if (data.length === array.length) {
            resolve(array);
          }
        });
      });
    });
  }

  private loadData(ids) {
    this.importService.find(0, 100, {
      _id: {
        $in: ids
      }
    }).then(resultImporter => {
      this.generateArray(resultImporter.data).then(result => {
        this.importIdsInfo = _.chain(<[]>result).sortBy('name').sortBy('importType').value();
      });
    });

  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Overview',
        callback: () => {
          this.router.navigate(['legacy-compositions']);
        }
      }),
      new PageAction({
        icon: 'edit',
        title: 'Edit Legacy Composition',
        callback: () => {
          this.router.navigate(['legacy-compositions', this.route.snapshot.params['id'], 'edit']);
        }
      }),
      new PageAction({
        icon: 'build',
        title: 'New Legacy Composition',
        callback: () => {
          this.router.navigate(['legacy-compositions/create']);
        }
      })
    ];
  }
}
